export default __webpack_public_path__ + "5f81e5bb62174c866cf368a01440e13b.svg";